import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { hsaContributionsIntial } from 'enrollment/services';
import {
  HSAContributionCardBackground,
  HSAContributionCardBoder,
} from './HSAContributionStyled';
import { convertCurrency } from "enrollment/utils";
import { PSBannerWrapper } from 'enrollment/components/Shared/Banner';

export function EmployerZeroContribution() {
  const { t } = useTranslation('pages.financial');
  const newHSAData = useSelector(hsaContributionsIntial);
  const currentPlanYear = newHSAData.current_plan_year;
  return (
    <div className="px-3_5 px-md-5 pb-3 mb-2" data-testid="employer-contribution-zero">
        <HSAContributionCardBoder>
            <HSAContributionCardBackground>
                <div className="text-center py-3_5">
                <div className="title-large">
                    {convertCurrency("0")}
                </div>
                <div className="title-medium semiBold">
                    {t('newHSA.title', { currentPlanYear })}{' '}
                </div>
                <div className="title-small">{t('newHSA.description')}</div>
                </div>
            </HSAContributionCardBackground>
            <div className="d-flex justify-content-center align-items-center my-3">
                <PSBannerWrapper
                    id="max-limit-banner"
                    message={t('contributionAdjustments.zeroMessage', {currentPlanYear})}
                    level="info"
                    icon
                />
            </div>
        </HSAContributionCardBoder>
    </div>
  );
}
